import { ShareType } from "@/helpers/enum";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { TYPE } from "vue-toastification";
import { openModal, popModal } from "jenesius-vue-modal";
import successPopup from "./components/AccountSetting/TwoFaAuthSuccess.vue";
const authData = ref([]);
const reactiveUser = ref<any>({});
const twoFaAuthenticated = ref<Boolean>(false);
export const twoFactAuthComposable = () => {
  const isLoading = ref(false);

  onMounted(() => {
    reactiveUser.value = storageService.getUser();
  });

  const loadTwoFaAuth = async () => {
    isLoading.value = true;
    try {
      const response = await httpService.twoFactorAuthentication();
      if (response.isSuccess) {
        authData.value = response.data;
        isLoading.value = false;
      }
    } catch (e) {
      isLoading.value = false;
    }
  };
  const deleteUserTwoFaNumber = async (i: any) => {
    var confirmRes = await utilService.showConfirmationDialog(
      "Are you sure you want to delete this number?"
    );
    if (confirmRes) {
      deleteItem(i);
    }
  };
  const deleteItem = async (i: any) => {
    try {
      const response = await httpService.deleteTwoFaAuth(i);
      if (response.data.isSuccess) {
        utilService.showToast(
          `Backup Number deleted successfully`,
          TYPE.SUCCESS
        );
        loadTwoFaAuth();
      }
    } catch (e) {}
  };
  const EnableAuth = async (i: any) => {
    try {
      const response = await httpService.updateTwoFaAuth(i);
      if (response.data.isSuccess) {
        utilService.showToast(
          `This number Enabled for Two-Factor Authentication`,
          TYPE.SUCCESS
        );
        loadTwoFaAuth();
      }
    } catch (e) {}
  };
  const updateAuthStatus = async () => {
    try {
      const response = await httpService.updateTwoFaAuthStatus();
      if (response.data.isSuccess) {
        reactiveUser.value.is2faAuthenticated =
          response.data.data.is2faAuthenticated;
        storageService.setUser(reactiveUser.value);
        if (response.data.data.is2faAuthenticated) {
          utilService.showToast(`Two Factor Authentication enabled`, TYPE.SUCCESS);
        }
        else {
          utilService.showToast(`Two Factor Authentication disabled`, TYPE.SUCCESS);
        }
      }
    } catch (e) {}
  };

  const verifyTwoFaPhoneNumber = async (i: any) => {
    try {
      const response = await httpService.twoFactorAuthenticationVerifyPhone({
        enrollmentId: i._id,
      });
      if (response.isSuccess) {
        reactiveUser.value.is2faAuthenticated = true;
        storageService.setUser(reactiveUser.value);
        utilService.showToast(
          `This number Enabled for Two-Factor Authentication`,
          TYPE.SUCCESS
        );
        openSuccessPopup(i.email);
        loadTwoFaAuth();
      }
    } catch (e) {}
  };

  const openSuccessPopup = async (userData: any) => {
    var modal = await openModal(successPopup, { userData: userData });
    modal.onclose = () => {};
  };

  return {
    loadTwoFaAuth,
    authData,
    deleteItem,
    isLoading,
    EnableAuth,
    openSuccessPopup,
    verifyTwoFaPhoneNumber,
    updateAuthStatus,
    reactiveUser,
    twoFaAuthenticated,
    deleteUserTwoFaNumber,
  };
};
